module.exports = __webpack_public_path__ + "15e5710f46658e64e6ae7bf146a10f66.svg";


//////////////////
// WEBPACK FOOTER
// ./images/group-icon-white.svg
// module id = 70
// module chunks = 0